import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Pagination = ({
  pagination = {},
  setOffset,
  offset,
  setLimit,
  limit,
  setGoto,
  goto,
  contentAfterTotalItems,
  dontShowActivePage = false,
  onClickOnPageNumber = () => {},
  disabled = false,
}) => {
  const totalPages = pagination.totalPages || 1;
  const pageCap = pagination.navTotalPages ?? pagination.totalPages ?? 1;
  const compactPartPaging =
    pagination.navTotalPages != null && pagination.navTotalPages !== totalPages;

  return (
    <>
      <div
        className="pagination"
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          // marginLeft:justifyContent==="center" ? "-40px" : "",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "auto",
          }}
        >
          <span style={{ color: "#666", fontSize: "12px", marginTop: "7.5px" }}>
            Total{" "}
            {(pagination?.visibleRowCount ?? pagination?.total) || 0} Items
          </span>
          &nbsp;&nbsp;
          {contentAfterTotalItems}
          <button
            onClick={() => {
              if (disabled) return;
              setOffset((prev) => Math.max(prev - limit, 0));
            }}
            disabled={offset === 0 || disabled}
            style={{
              padding: "4px 8px",
              border: "2px solid #f4eaea",
              opacity: disabled ? 0.5 : 1,
              cursor: disabled ? "not-allowed" : "pointer",
            }}
          >
            <FontAwesomeIcon
              style={{ fontSize: "10px", color: "#0D6EFD" }}
              icon={faChevronLeft}
            />
          </button>
          {/* Custom Pagination Buttons */}
          {compactPartPaging ? (
            <span
              style={{
                fontSize: "12px",
                color: "#333",
                padding: "0 10px",
                marginTop: "4px",
                whiteSpace: "nowrap",
              }}
            >
              {pagination.visibleRowCount != null ? (
                <>
                  Page 1 of 1
                  {!pagination.hideBatchIndicator && pageCap > 1 ? (
                    <span style={{ color: "#888" }}>
                      {" "}
                      · Batch {Math.floor(offset / limit) + 1}/{pageCap}
                    </span>
                  ) : null}
                </>
              ) : (
                <>
                  Page {Math.floor(offset / limit) + 1} of {pageCap}
                </>
              )}
            </span>
          ) : (
            (() => {
            const totalPages = pagination.totalPages || 1;
            const currentPage = Math.floor(offset / limit);
            const buttons = [];

            const showLeftDots = currentPage > 3;

            const showRightDots = currentPage < totalPages - 4;
            const showFirstActivePage =
              currentPage === 0 && !dontShowActivePage ? true : false;
            // Always show first page
            buttons.push(
              <button
                key={0}
                onClick={() => {
                  if (disabled) return;
                  setOffset(0);
                  if (onClickOnPageNumber) onClickOnPageNumber();
                }}
                disabled={disabled}
                style={{
                  padding: "4px 8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  cursor: disabled ? "not-allowed" : "pointer",
                  opacity: disabled ? 0.5 : 1,
                  backgroundColor: showFirstActivePage
                    ? "#0D6EFD"
                    : "transparent",
                  color: showFirstActivePage ? "white" : "black",
                }}
              >
                1
              </button>
            );

            if (showLeftDots) {
              buttons.push(
                <span key="dots-left" style={{ padding: "0 6px" }}>
                  ...
                </span>
              );
            }

            const startPage = Math.max(1, currentPage - 2);
            const endPage = Math.min(totalPages - 2, currentPage + 2);

            for (let i = startPage; i <= endPage; i++) {
              const showActivePage =
                currentPage === i && !dontShowActivePage ? true : false;
              buttons.push(
                <button
                  key={i}
                  onClick={() => {
                    if (disabled) return;
                    setOffset(i * limit);
                    if (onClickOnPageNumber) onClickOnPageNumber();
                  }}
                  disabled={disabled}
                  style={{
                    padding: "4px 8px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.5 : 1,
                    backgroundColor: showActivePage ? "#0D6EFD" : "transparent",
                    color: showActivePage ? "white" : "black",
                  }}
                >
                  {i + 1}
                </button>
              );
            }

            if (showRightDots) {
              buttons.push(
                <span key="dots-right" style={{ padding: "0 6px" }}>
                  ...
                </span>
              );
            }

            // Always show last page if it's not already included
            if (totalPages > 1) {
              buttons.push(
                <button
                  key={totalPages - 1}
                  onClick={() => {
                    if (disabled) return;
                    setOffset((totalPages - 1) * limit);
                    if (onClickOnPageNumber) onClickOnPageNumber();
                  }}
                  disabled={disabled}
                  style={{
                    padding: "4px 8px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.5 : 1,
                    backgroundColor:
                      currentPage === totalPages - 1 && !dontShowActivePage
                        ? "#0D6EFD"
                        : "transparent",
                    color:
                      currentPage === totalPages - 1 && !dontShowActivePage
                        ? "white"
                        : "black",
                  }}
                >
                  {totalPages}
                </button>
              );
            }

            return buttons;
            })()
          )}
          <button
            onClick={() => {
              if (disabled) return;
              setOffset((prev) => prev + limit);
            }}
            disabled={offset / limit + 1 >= pageCap || disabled}
            style={{
              padding: "4px 8px",
              border: "1px solid #ddd",
              opacity: disabled ? 0.5 : 1,
              cursor: disabled ? "not-allowed" : "pointer",
            }}
          >
            <FontAwesomeIcon
              style={{ fontSize: "10px", color: "#0D6EFD" }}
              icon={faChevronRight}
            />
          </button>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              marginLeft: "10px",
            }}
          >
            <select
              value={limit}
              onChange={(e) => {
                if (disabled) return;
                const newLimit = Number(e.target.value);
                setLimit(newLimit);
                setOffset(0);
              }}
              disabled={disabled}
              style={{
                fontSize: "12px",
                padding: "6px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                color: "#6c757d",
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? "not-allowed" : "pointer",
              }}
            >
              {[10, 20, 50, 100, 200, 300, 400, 500].map((size) => (
                <option key={size} value={size}>
                  {size}/page
                </option>
              ))}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              marginLeft: "8px",
            }}
          >
            <span style={{ fontSize: "12px", color: "#333" }}>Go to</span>
            <input
              type="number"
              min={1}
              max={pageCap}
              value={goto}
              onChange={(event) => {
                if (disabled) return;
                setGoto(event.target.value);
              }}
              onKeyDown={(e) => {
                if (disabled) {
                  e.preventDefault();
                  return;
                }
                if (e.key === "Enter") {
                  const val = Number(e.target.value);
                  if (val > pageCap) {
                    e.target.blur();
                    setGoto("");
                    setTimeout(() => {
                      alert(
                        `Please enter value less than or equal to ${pageCap}`
                      );
                    }, 100);
                    return;
                  }
                  const page = Math.max(
                    1,
                    Math.min(val, pageCap)
                  );
                  setOffset((page - 1) * limit);
                  if (onClickOnPageNumber) onClickOnPageNumber();
                  setGoto("");
                  e.target.blur();
                }
              }}
              disabled={disabled}
              style={{
                width: "50px",
                padding: "6px",
                fontSize: "12px",
                color: "#6c757d",
                border: "1px solid #ccc",
                borderRadius: "4px",
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? "not-allowed" : "text",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Pagination;
